module.exports = __webpack_public_path__ + "media/600_HC_2023_The_Anatomy_of_a_Phishing_Email.d97312b7.mp4";